import image from "../../assets/pagebanner1.jpg";

export const ACTION = [
  {
    img: image,
  },
];
